export const ScheduleIcon = ({selected}) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 9.16699H5.83333V10.8337H7.5V9.16699ZM10.8333 9.16699H9.16667V10.8337H10.8333V9.16699ZM14.1667 9.16699H12.5V10.8337H14.1667V9.16699ZM15.8333 3.33366H15V1.66699H13.3333V3.33366H6.66667V1.66699H5V3.33366H4.16667C3.24167 3.33366 2.50833 4.08366 2.50833 5.00033L2.5 16.667C2.5 17.5837 3.24167 18.3337 4.16667 18.3337H15.8333C16.75 18.3337 17.5 17.5837 17.5 16.667V5.00033C17.5 4.08366 16.75 3.33366 15.8333 3.33366ZM15.8333 16.667H4.16667V7.50033H15.8333V16.667Z" fill={ selected ? "white" : "rgba(255, 255, 255, 0.7)" }/>
        </svg>

    )
}
